/* 加密算法
 *  采用aes-128-ecp算法
 *  key必须为16字节utf8字符（如英文字母、数字等等）
 *  iv设置为空‘’
 *  输出为hex打斜字符串（大小写不影响解密）
 */

import CryptoJS from 'crypto-js'
// const key = '1234567899876543'
// const iv = ''

const key = CryptoJS.enc.Utf8.parse('123456789asdfgew')
const iv = CryptoJS.enc.Utf8.parse('2C5A0BBE5141AAD4')
export function encryption (word) {
  const srcs = CryptoJS.enc.Utf8.parse(word)
  const wordStr = CryptoJS.enc.Utf8.stringify(srcs)
  const encrypted = CryptoJS.AES.encrypt(wordStr, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  })
  return encrypted.toString()
}
export function decryption (word) {
  const base64 = CryptoJS.enc.Base64.parse(word)
  const wordStr = CryptoJS.enc.Base64.stringify(base64)
  const decrypted = CryptoJS.AES.decrypt(wordStr, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  })
  return decrypted.toString(CryptoJS.enc.Utf8)
}
